var map = {
	"./ic-about.svg": "3781",
	"./ic-certificate.svg": "bb12",
	"./ic-contact.svg": "d19f",
	"./ic-home.svg": "e9e9",
	"./ic-project.svg": "82c5",
	"./ic-work.svg": "cd96",
	"./ic-work_.svg": "c958"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f4a3";